// extracted by mini-css-extract-plugin
module.exports = {"login":"CreditsUnauth_login__fjylC","button":"CreditsUnauth_button__3GDcM"};